export default (store, to ) => {
    if (store.state.metaInfo.items.length > 0) {
        for(let i=0; i<store.state.metaInfo.items.length; i++) {
            if(to.path==store.state.metaInfo.items[i].path){
                let head = document.head;
                if ('title' in store.state.metaInfo.items[i]) {
                    document.title = store.state.metaInfo.items[i].title;
                }
                if ('keywords' in store.state.metaInfo.items[i]) {
                    let keywords = head.querySelector('meta[name="Keywords"]');
                    if (keywords == undefined){
                        keywords = document.createElement('meta'); 
                        keywords.setAttribute('name', 'Keywords');
                        head.appendChild(keywords);
                    }
                    keywords.setAttribute('content', store.state.metaInfo.items[i].keywords);
                }
                if ('description' in store.state.metaInfo.items[i]) {
                    let description = head.querySelector('meta[name="description"]');
                    if (description == undefined){
                        description = document.createElement('meta'); 
                        description.setAttribute('name', 'description');
                        head.appendChild(description);
                    }
                    description.setAttribute('content',  store.state.metaInfo.items[i].description);
                }
                break;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/meta.js